let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iOlJ7")).then(() => parcelRequire('9iqsx'));